module.exports = __webpack_public_path__ + "resources/img/bg_cover_support.42fe42b4a20aab29e956789608b61cbd.png";